import { render } from "./CalendarLesson.vue?vue&type=template&id=739067c7&scoped=true"
import script from "./CalendarLesson.vue?vue&type=script&lang=js"
export * from "./CalendarLesson.vue?vue&type=script&lang=js"

import "./CalendarLesson.vue?vue&type=style&index=0&id=739067c7&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-739067c7"]])

export default __exports__